<bn-loading-overlay></bn-loading-overlay>
<div class="row cabecalho-recuperacao">         
    <div class="col">
        <h3>Recuperação de crédito</h3>
    </div>
    <div class="col-auto">
        <button *ngIf="podeEnviarRecCredito" class="btn btn-primary" type="button" (click)="inclui()" 
        ngbTooltip="Incluir"><i class="fa fa-plus-circle"></i> Nova recuperação</button>
        <button *ngIf="podeEnviarRecCredito && modoEdicao && recuperacoes?.length" type="button" class="btn btn-primary"
        [disabled]="!executarValidacoesPreliminares()"  
        (click)="validar()">Validar
      </button>
        <button *ngIf="podeEnviarRecCredito && modoEdicao && recuperacoes?.length" type="button" class="btn btn-primary" 
        [disabled]="!executarValidacoesPreliminares()" 
        (click)="salvar()">Enviar
      </button>
        <button type="button" class="btn btn-danger" (click)="voltarParaLista ()">Voltar</button>
    </div>
</div>   
<div class="row linha-recuperacao" *ngFor="let recuperacao of recuperacoes; let i = index">
    <div class="col-md-2">
        <a (click)="remove(recuperacao)" *ngIf="modoEdicao"><i class="fa fa-trash cursor-pointer"></i></a>&nbsp;
        <label><b>Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i></b>
        </label>
        <select class="form-select" (change)="atribuiSistema(recuperacao, $event.target.value)" [disabled]="!modoEdicao">
        <option value='CL'>Crédito Livre</option>
        <option value='15'>15 - FINAME</option>
        <option value='89'>89 - BNDES</option>
        </select>
    </div>
    <div class="col-md-2" *ngIf="!recuperacao.sistemaRepasse">
        <label>Id. externo operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Identificador da operação informado pelo Agente Financeiro em operações de Crédito Livre."></i>
        </label>
        <input type="text" class="form-control" [(ngModel)]="recuperacao.idOperacaoExterno" required pattern="[a-zA-Z0-9\-_]{1,20}" [disabled]="!modoEdicao">
    </div>

    <div class="col-md-2" *ngIf="recuperacao.sistemaRepasse == '15' || recuperacao.sistemaRepasse == '89'">
        <label>Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
        </label>
        <input type="text" class="form-control" [(ngModel)]="recuperacao.contratoRepasse" required pattern="[0-9]{11}" [disabled]="!modoEdicao" >
    </div>

    <div class="col-md-2">
        <label>Data da recuperação: </label>
        <bn-datepicker name="dataRecuperacao{{i}}" [(ngModel)]="recuperacao.dataRecuperacao" required [disabled]="!modoEdicao"></bn-datepicker>
    </div>

    <div class="col-md-2">
        <label>Valor da recuperação: </label>
        <input type="text" class="form-control moeda" [(ngModel)]="recuperacao.valorRecuperacao" bnMask="MOEDA" required [disabled]="!modoEdicao" />
    </div>

    <div class="col-md-2">
        <label>Saldo Liquidado: </label>
        <input type="checkbox" class="form-check checkbox-gigante" [(ngModel)]="recuperacao.saldoLiquidado" required [disabled]="!modoEdicao" />
    </div>
</div>